// extracted by mini-css-extract-plugin
export default {"dates":"components-GameDateRange-styles-module__dates--Axn2G"};